import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class ExcelInventoryImport_ds_get_materialpackagings_by_shortnamesService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { shortNames: string[] }): 
  Promise<{ result: { Id?: number, ShortName?: string }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.shortNames)) {
      missingRequiredInParams.push('\'shortNames\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/ExcelInventoryImport/datasources/ds_get_materialpackagings_by_shortnames/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { shortNames: string[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ShortName?: string }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.shortNames)) {
      missingRequiredInParams.push('\'shortNames\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/ExcelInventoryImport/datasources/ds_get_materialpackagings_by_shortnames/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { shortNames: string[], $keys: number[] }): 
  Promise<{ result: { Id?: number, ShortName?: string }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.shortNames)) {
      missingRequiredInParams.push('\'shortNames\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/ExcelInventoryImport/datasources/ds_get_materialpackagings_by_shortnames/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      shortNames: string[]    }) {
        if(isNil(inParams.shortNames)) {
          return true; 
        }
      return false;
    }
}
